import PropTypes from "prop-types";
import React, { Component } from "react";
import { SPOILER_TEXT_AREA } from "./../../_shared/data-hooks.js";
import { EditableTextInput as EditableInputWrapper } from "./editable-input-wrapper.js";
class SpoilerDescriptionInput extends Component {
  constructor() {
    super(...arguments);
    this.onChange = (e) => this.props.onChange(e.target.value);
    // @ts-expect-error
    this.setTextAreaRef = (ref) => this.textAreaRef = ref;
  }
  componentDidUpdate() {
    this.fixTextAreaHeight();
  }
  fixTextAreaHeight() {
    if (this.textAreaRef?.style) {
      this.textAreaRef.style.height = "";
      this.textAreaRef.style.height = this.textAreaRef.scrollHeight + "px";
    }
  }
  render() {
    const { className, onChange, value, setFocusToBlock, setInPluginEditingMode } = this.props;
    const InputComponent = /* @__PURE__ */ React.createElement(
      "textarea",
      {
        ref: this.setTextAreaRef,
        className,
        rows: 1,
        maxLength: 70,
        "data-hook": SPOILER_TEXT_AREA
      }
    );
    return onChange ? /* @__PURE__ */ React.createElement(
      EditableInputWrapper,
      {
        InputComponent,
        value,
        onChange: this.onChange,
        setInPluginEditingMode,
        setFocusToBlock
      }
    ) : /* @__PURE__ */ React.createElement("span", { className, dir: "auto", style: { display: "block", maxWidth: "89%" } }, value);
  }
}
SpoilerDescriptionInput.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  setFocusToBlock: PropTypes.func,
  setInPluginEditingMode: PropTypes.func
};
export {
  SpoilerDescriptionInput
};
//# sourceMappingURL=spoiler-description-input.js.map
